import {z} from 'zod';

export const HeaderDynamicActionsResourcesSchema = z.union([
  z.literal('delivery-note'),
  z.literal('direct-sale'),
  z.literal('credit-note'),
  z.literal('service-order-issue-note'),
  z.literal('parts-request-return'),
  z.literal('service-order-return'),
  z.literal('service-case-order'),
  z.literal('receive-note'),
  z.literal('supplier-order'),
  z.literal('article-update-job'),
  z.literal('fast-track'),
  z.literal('issue-note'),
  z.literal('issue-note-correction'),
  z.literal('cost-correction'),
  z.literal('transfer-order'),
  z.literal('article'),
]);
export type HeaderDynamicActionsResources = z.infer<typeof HeaderDynamicActionsResourcesSchema>;

export const HeaderActionTypeSchema = z
  .union([z.literal('FE'), z.literal('BE'), z.literal('PRINTOUT')])
  .optional();
export type HeaderActionType = z.infer<typeof HeaderActionTypeSchema>;

export const HeaderDynamicActionsOptionsSchema = z.array(
  z.object({
    key: z.string(),
    style: z.union([z.literal('enable'), z.literal('hidden'), z.literal('disabled')]),
    position: z.number(),
    title: z.string(),
    variant: z.string().optional(),
    type: HeaderActionTypeSchema,
    tooltip: z
      .object({
        label: z.string().optional(),
        description: z.string().optional(),
      })
      .optional(),
  })
);

export type HeaderDynamicActionsOptions = z.infer<typeof HeaderDynamicActionsOptionsSchema>;

export const HeaderDynamicActionsResponseSchema = z.object({
  actions: z.object({
    optionClick: z.union([z.string(), z.array(z.string())]),
    options: HeaderDynamicActionsOptionsSchema,
  }),
});
export type HeaderDynamicActionsResponse = z.infer<typeof HeaderDynamicActionsResponseSchema>;

export const HeaderDynamicActionsRequestSchema = z.object({
  resource: HeaderDynamicActionsResourcesSchema,
  id: z.string(),
});
export type HeaderDynamicActionsRequest = z.infer<typeof HeaderDynamicActionsRequestSchema>;

export const HeaderDynamicActionsEventRequestSchema = z.object({
  id: z.string(),
  version: z.string().optional(), // An optional version field defined by the FE to preserve dynamic functionality and prevent breaking changes when new versions are introduced.
  resource: HeaderDynamicActionsResourcesSchema,
  body: z.object({
    actionKey: z.string(),
    returnedBy: z.string().optional(),
    originEntityHeaderType: HeaderDynamicActionsResourcesSchema.optional(),
    newDirectSaleVariantId: z.string().optional(),
    plannedDate: z.date().optional(),
    receivedBy: z.string().optional(),
    deleteEmptySorPromptResponseCode: z.enum(['DELETE', 'DONT_DELETE']).nullish(),
  }),
});

export type HeaderDynamicActionsEventRequest = z.infer<
  typeof HeaderDynamicActionsEventRequestSchema
>;

export const HeaderDynamicActionsEventResponseSchema = z.object({
  deleteEmptySorPrompt: z.boolean(),
});
export type HeaderDynamicActionsEventResponse = z.infer<
  typeof HeaderDynamicActionsEventResponseSchema
>;
